import updateProfile from './updateProfile';

export default (path, version = 'v1', namespace = 'afosto') => async views => {
  try {
    const positionsPath = `${namespace}.me.${path}.${version}.positions`;
    await updateProfile(
      positionsPath,
      views.map(view => view.key),
    );

    return Promise.resolve();
  } catch (err) {
    return Promise.reject(err);
  }
};
